// extracted by mini-css-extract-plugin
module.exports = {"content":"AccountDeletionModal_content__2yJkq","fullWidth":"AccountDeletionModal_fullWidth__3hjox"};